import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Libraries
import noUiSlider from 'nouislider'
import ReactRailsUJS from 'react_ujs'
import { Viewer as PhotoSphereViewer } from '@photo-sphere-viewer/core'

const componentRequireContext = require.context('components', true)

ReactRailsUJS.useContext(componentRequireContext)

window.noUiSlider = noUiSlider
window.PhotoSphereViewer = { Viewer: PhotoSphereViewer }
